import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

const initialState = {
  showSpinner: false,
};

const spinnerSlice = createSlice({
  name: 'spinnerSlice',
  initialState,
  reducers: {
    setShowSpinner(state, { payload }: PayloadAction<boolean>) {
      state.showSpinner = payload;
    }
  },
});

export const { setShowSpinner } = spinnerSlice.actions;

export const selectShowSpinner = (state: RootState) =>
  state.spinnerSlice.showSpinner;

export default spinnerSlice.reducer;